import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'
import ProtectedRoute from './routing/ProtectedRoute'
import './scss/style.scss'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="*" name="Главная" element={<DefaultLayout />} />
            </Route>
            <Route exact path="/login" name="Login Page" element={<Login />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
